document.querySelectorAll('section.header [data-scroll-down]').forEach((button) => {
	button.addEventListener('click', () => {
		const section = button.closest('section');
		if (!section) {
			return;
		}

		const nextSection = section.nextElementSibling;
		if (nextSection) {
			nextSection.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
			return;
		}

		const styles = getComputedStyle(document.documentElement);
		const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
		const headerHeight = parseFloat(
			styles.getPropertyValue(isDesktop ? '--strl-header-height' : '--strl-m-header-height')
		) || 0;

		window.scrollTo({
			top: section.getBoundingClientRect().bottom + window.scrollY - headerHeight,
			behavior: 'smooth',
		});
	});
});
